// Lokasi: src/services/Master/MasterJenisSeleksi.js

import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE; // Ensure this env variable is set

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});

// --- Fetch all Jenis Seleksi dengan parameter tunggal 'options' ---
// 'options' bisa berisi:
//   - page: (number) nomor halaman
//   - per_page: (number) jumlah item per halaman
//   - filters: (object) objek filter seperti { nama_seleksi: "..." }
//   - disable_pagination: (boolean) true jika ingin mengambil semua data tanpa paginasi
export const fetchJenisSeleksi = async (options = {}) => {
  try {
    const params = new URLSearchParams();

    // Pastikan options.filters ada dan berbentuk objek
    const filters = options.filters || {};
    
    // DEBUG: Console log untuk melihat filter yang masuk
    // console.log("Incoming options:", options);
    // console.log("Filters used for API:", filters);

    // Menambahkan filter untuk Tipe Konten
    // Service Anda saat ini mungkin mengirim filters: {id_tipe_konten: 'X'} dari komponen
    if (filters.id_tipe_konten) {
      params.append('id_tipe_konten', filters.id_tipe_konten);
    }
    
    // Menambahkan filter untuk Nama Seleksi (search)
    // Di komponen React, ini dikirim sebagai filters: {nama_seleksi: 'X'}
    if (filters.nama_seleksi) {
      // Menggunakan 'search' sebagai nama parameter di API (sesuai implementasi lama Anda)
      params.append('search', filters.nama_seleksi); 
    }
    
    // Perhatikan: Jika API backend Anda menggunakan 'nama_seleksi' sebagai parameter filter,
    // ganti 'search' di atas dengan 'nama_seleksi'.
    // Contoh: params.append('nama_seleksi', filters.nama_seleksi);

    // Anda bisa menghapus blok ini jika Anda hanya menggunakan filters.nama_seleksi
    // if (options.search) {
    //   params.append('search', options.search);
    // }

    // Pagination logic
    if (options.disable_pagination) {
      params.append('disable_pagination', 'true');
    } else {
      params.append('page', options.page || 1);
      params.append('per_page', options.per_page || 10);
    }

    const response = await axios.get(`${BASE_URL_BE}/jenis_seleksi?${params.toString()}`, {
      headers: getAuthHeaders()
    });

    const meta = response.data.meta || {};
    const calculated_last_page = options.disable_pagination ? 1 : (Math.ceil(meta.total / meta.per_page) || 1);
    const currentPage = options.disable_pagination ? 1 : (meta.page || (options.page || 1));
    const currentPerPage = options.disable_pagination ? (meta.total || response.data.data.length || (options.per_page || 10)) : (meta.per_page || (options.per_page || 10));

    return {
      success: response.data.success,
      data: response.data.data || [],
      message: response.data.message || "",
      code: response.data.code || 200,
      meta: {
        page: currentPage,
        per_page: currentPerPage,
        total: meta.total || (options.disable_pagination ? response.data.data.length : 0),
        last_page: calculated_last_page
      }
    };
  } catch (error) {
    console.error("Error fetching Jenis Seleksi:", error);
    throw {
      success: false, 
      message: error.response?.data?.message || "Failed to fetch jenis seleksi",
      errors: error.response?.data?.errors,
      code: error.response?.status
    };
  }
};

export const fetchJenisSeleksiByParentID = async (parentId, idTipeKonten, options = {}) => {
  try {
    const params = new URLSearchParams();
    // Tidak perlu menambahkan parentId ke params karena sudah di path
    const response = await axios.get(`${BASE_URL_BE}/jenis_seleksi/sub-paket?id_jenis_seleksi=${parentId}&id_tipe_konten=${idTipeKonten}`, {
      headers: getAuthHeaders()
    });
    // ... (logika pagination dan return yang sama)
    return {
      success: response.data.success,
      data: response.data.data || [],
      // ...
    };
  } catch (error) {
    // ... (logika error yang sama)
  }
};


export const fetchJenisSeleksiParentID = async (options = {}) => {
  try {
    const params = new URLSearchParams();

    // Logika untuk paginasi atau disable_pagination
    if (options.disable_pagination) {
      params.append('disable_pagination', 'true');
    } else {
      params.append('page', options.page || 1);
      params.append('per_page', options.per_page || 10);
    }

    if (options.id_tipe_konten) {
      params.append('id_tipe_konten', options.id_tipe_konten);
    }

    console.log(options.nama_seleksi, "ini nama seleksi ")



    const response = await axios.get(`${BASE_URL_BE}/jenis_seleksi/parent_id?${params.toString()}`, {
      headers: getAuthHeaders()
    });

    const meta = response.data.meta || {};
    const calculated_last_page = options.disable_pagination ? 1 : (Math.ceil(meta.total / meta.per_page) || 1);
    const currentPage = options.disable_pagination ? 1 : (meta.page || (options.page || 1));
    const currentPerPage = options.disable_pagination ? (meta.total || response.data.data.length || (options.per_page || 10)) : (meta.per_page || (options.per_page || 10));

    return {
      success: response.data.success, // Pastikan success juga dikembalikan dari API
      data: response.data.data || [],
      message: response.data.message || "",
      code: response.data.code || 200,
      meta: {
        page: currentPage,
        per_page: currentPerPage,
        total: meta.total || (options.disable_pagination ? response.data.data.length : 0),
        last_page: calculated_last_page
      }
    };
  } catch (error) {
    console.error("Error fetching Jenis Seleksi:", error); // Diperbarui log pesan error
    // Mengembalikan objek error yang lebih informatif jika request gagal
    throw { // Melempar objek error agar bisa ditangkap oleh toast.error
      success: false, 
      message: error.response?.data?.message || "Failed to fetch jenis seleksi.",
      errors: error.response?.data?.errors,
      code: error.response?.status
    };
  }
};



// --- Create a new Jenis Seleksi ---
export const createJenisSeleksi = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL_BE}/jenis_seleksi`, formData, { 
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data' 
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating Jenis Seleksi:", error); 
    throw error;
  }
};

// --- Update an existing Jenis Seleksi ---
export const updateJenisSeleksi = async (id_jenis_seleksi, formData) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}/jenis_seleksi/${id_jenis_seleksi}`, formData, { // Menggunakan axios.put untuk update
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data' 
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating Jenis Seleksi:", error); 
    throw error;
  }
};

// --- Delete a Jenis Seleksi ---
export const deleteJenisSeleksi = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}/jenis_seleksi/${id}`, { 
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting Jenis Seleksi:", error); 
    throw error;
  }
};